import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Observable} from 'rxjs';

@Injectable()
export default class ActionService {
  public constructor(private http: HttpClient) {
  }
  public execute<T>(action: string, payload: any): Observable<T> {
    return this.http.post<T>(environment.apiUrl + '/action/' + action, payload);
  }
}
